<template>
    <div class="Exporter">
        <ul class="Utility__list-inline">
            <li v-show="exportsPdf">
                <a href="#" title="Export to PDF" @click.prevent="exportTo('pdf')">
                    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                </a>
            </li>
            <li v-show="exportsExcel">
                <a href="#" title="Export to Excel" @click.prevent="exportTo('excel')">
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                </a>
            </li>
        </ul>

        <form :action="action" method="post" ref="form">
            <input name="_token" type="hidden" :value="csrfToken">
            <input name="reportType" type="hidden" :value="reportType">
            <input name="vehicleType" type="hidden" :value="vehicleType">
            <input name="title" type="hidden" :value="title">
            <input name="columns" type="hidden" :value="JSON.stringify(columns)">
            <input name="columnFormats" type="hidden" :value="JSON.stringify(columnFormats)">
            <input name="rows" type="hidden" :value="JSON.stringify(rows)">
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken,
                action: '',
            }
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            columnFormats: {
                type: Array,
            },

            columns: {
                type: Array,
            },

            rows: {
                type: Array,
            },

            graph: {
                type: String
            },

            reportType: {
                type: String,
                default: 'table',
            },

            vehicleType: {
                type: String,
                required: true,
            },

            exportsExcel: {
                default: true,
                type: Boolean,
            },

            exportsPdf: {
                default: true,
                type: Boolean,
            }
        },

        methods: {
            exportTo(type) {
                this.action = '/motorstats/export/' + type;

                _.defer(() => {
                    this.$refs.form.submit();
                })
            }
        }
    }
</script>